import React from "react";

const FEEDBACK_FORM_URL = "https://survey.hsforms.com/1y10-s7HCQo-avzvD2-aAaA3soj5";

const buttonStyle = {
  position: "fixed",
  bottom: "32px",
  right: "32px",
  zIndex: 1000,
  background: "linear-gradient(90deg, #4f8cff 0%, #3358ff 100%)",
  color: "#fff",
  border: "none",
  borderRadius: "50px",
  padding: "16px 28px",
  fontSize: "1rem",
  fontWeight: "bold",
  boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
  cursor: "pointer",
  transition: "background 0.2s, box-shadow 0.2s",
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const iconStyle = {
  width: "20px",
  height: "20px",
  display: "inline-block",
};

export default function FeedbackButton() {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <button
        type="button"
        style={buttonStyle}
        aria-label="Give Feedback"
        onClick={() => setOpen(true)}
      >
        <svg
          style={iconStyle}
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
        >
          <path
            d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
          />
        </svg>
        Feedback
      </button>
      {open && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.4)",
            zIndex: 2000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => setOpen(false)}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "12px",
              width: "80vw",
              //maxWidth: "600px",
              minHeight: "90vh",
              boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
              position: "relative",
              padding: "0",
              display: "flex",
              flexDirection: "column",
            }}
            onClick={e => e.stopPropagation()}
          >
            <button
              onClick={() => setOpen(false)}
              style={{
                position: "absolute",
                top: "12px",
                right: "16px",
                background: "none",
                border: "none",
                fontSize: "1.5rem",
                cursor: "pointer",
                color: "#333",
              }}
              aria-label="Close"
            >
              &times;
            </button>
            <iframe
              src={FEEDBACK_FORM_URL}
              title="Feedback Form"
              style={{
                border: "none",
                width: "100%",
                height: "400px",
                borderRadius: "12px",
                flex: 1,
              }}
              allowFullScreen
            />
          </div>
        </div>
      )}
    </>
  );
}